import { render, staticRenderFns } from "./DownloadAcademicPerformances.vue?vue&type=template&id=422a2108"
import script from "./DownloadAcademicPerformances.vue?vue&type=script&lang=js"
export * from "./DownloadAcademicPerformances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports